/**
 * Bottom-left legend overlay. Static colour swatches + a one-liner about
 * marker size, both i18n-driven.
 */
import { useLocale, t } from "../../../shared/i18n";
import { CLOSED_COLOR, OPEN_COLOR, type MapColorMode } from "./constants";

export function MapLegend({
  colorMode = "status",
}: {
  colorMode?: MapColorMode;
}) {
  const locale = useLocale();
  // In "won" mode every dot is the wins blue, so the two-colour status
  // legend (and its "colour = status" footnote) would be misleading.
  if (colorMode === "won") {
    return (
      <div className="cn-map-panel cn-map-legend">
        <div className="cn-map-legend__title">
          {t("map.legendTitle", {}, locale)}
        </div>
        <div className="cn-map-legend__item">
          <span
            className="cn-map-legend__dot"
            style={{ background: CLOSED_COLOR }}
          />
          {t("map.legendWon", {}, locale)}
        </div>
      </div>
    );
  }
  return (
    <div className="cn-map-panel cn-map-legend">
      <div className="cn-map-legend__title">
        {t("map.legendTitle", {}, locale)}
      </div>
      <div className="cn-map-legend__item">
        <span
          className="cn-map-legend__dot"
          style={{ background: CLOSED_COLOR }}
        />
        {t("map.legendClosed", {}, locale)}
      </div>
      <div className="cn-map-legend__item">
        <span
          className="cn-map-legend__dot"
          style={{ background: OPEN_COLOR }}
        />
        {t("map.legendOpen", {}, locale)}
      </div>
      <div className="cn-map-legend__small">
        {t("map.legendSize", {}, locale)}
      </div>
    </div>
  );
}
